import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const MemberAuthContext = createContext(null);

const TOKEN_KEY = "godsc_member_token";

export const MemberAuthProvider = ({ children }) => {
  const [member, setMember] = useState(null); // null = checking, false = not auth, object = auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setMember(false);
      setLoading(false);
      return;
    }
    api
      .get("/members/me", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setMember(res.data.member))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setMember(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (memberId, pin) => {
    const { data } = await api.post("/members/login", { member_id: memberId, pin });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setMember(data.member);
    return data;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setMember(false);
  };

  return (
    <MemberAuthContext.Provider value={{ member, loading, login, logout, tokenKey: TOKEN_KEY }}>
      {children}
    </MemberAuthContext.Provider>
  );
};

export const useMemberAuth = () => useContext(MemberAuthContext);
export const MEMBER_TOKEN_KEY = TOKEN_KEY;
